function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.66 32.464a2.285 2.285 0 0 1-2.284-2.285v-19.8a2.284 2.284 0 0 1 3.485-1.942l15.806 9.566a2.283 2.283 0 0 1 .056 3.849l-15.807 10.231a2.259 2.259 0 0 1-1.256.381zm0-22.225a.144.144 0 0 0-.07.021.127.127 0 0 0-.071.122v19.8a.14.14 0 0 0 .216.117l15.807-10.231a.131.131 0 0 0 .062-.119.129.129 0 0 0-.066-.116l-15.806-9.566a.13.13 0 0 0-.071-.028z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M13.521 33.824a2.287 2.287 0 0 1-2.284-2.285v-19.8a2.284 2.284 0 0 1 3.485-1.943l15.806 9.566a2.284 2.284 0 0 1 .056 3.85L14.778 33.451a2.306 2.306 0 0 1-1.257.373zm0-22.225a.149.149 0 0 0-.07.02.128.128 0 0 0-.071.122v19.8a.14.14 0 0 0 .216.117l15.807-10.231a.14.14 0 0 0 0-.235l-15.806-9.566a.135.135 0 0 0-.075-.027z"
});

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.1a3e859b.svg";
export { ForwardRef as ReactComponent };